/* Copyright (C) 2020 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
// 2. Store and Types. 

export default interface IOrdersLineItemsEditorState
{
	bEnableTaxLineItems?  : boolean;
	bEnableTaxShipping?   : boolean;
	bShowTax?             : boolean;
	bEnableSalesTax?      : boolean;
	bDisableExchangeRate? : boolean;
	oNumberFormat?        : any;

	CURRENCY_ID?          : string;
	// 11/12/2022 Paul.  We can't dynamically convert to a number as it will prevent editing. 
	EXCHANGE_RATE?        : string;
	TAXRATE_ID?           : string;
	SHIPPER_ID?           : string;

	CURRENCY_ID_LIST?     : any[];
	TAXRATE_ID_LIST?      : any[];
	SHIPPER_ID_LIST?      : any[];

	SUBTOTAL?             : number;
	DISCOUNT?             : number;
	// 11/12/2022 Paul.  We can't dynamically convert to a number as it will prevent editing. 
	SHIPPING?             : string;
	TAX?                  : number;
	TOTAL?                : number;
}

